import Navigation from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import { Fragment } from "react/cjs/react.production.min";
import { useEffect, useState } from "react";
// import api from "../../api";
import URLS from "../../constants";
import { Helmet } from "react-helmet";

const About = () => {
  // const [teamMemberList, setTeamMemberList] = useState([]);
  // teamMemberList.sort((a, b) => {
  //   return a.name.localeCompare(b.name);
  // });
  // let management = teamMemberList.filter((teamMemberList) => {
  //   return teamMemberList.role === "Management";
  // });
  // let advisor = teamMemberList.filter((teamMemberList) => {
  //   return teamMemberList.role === "Advisor";
  // });

  const management = [
    {
      name: "Aniruddha Pant",
      image_url:
        "https://algoanalytics-bucket.s3.ap-south-1.amazonaws.com/team_members/17/meet-img1.png",
      image_alt: "Innovative leader Aniruddha Pant, pioneering AI and finance at AlgoAnalytics",
      designation: "CEO and Founder",
      description:
        "PhD University of California, Berkeley. 25+ years of experience in the application of advanced mathematical techniques. Expertise across financial engineeering, quant trading and deep learning.",
      linkedin_link: "https://in.linkedin.com/in/aniruddhapant",
      role: "Management",
    },
    {
      name: "Girish Patil",
      image_url:
        "https://algoanalytics-bucket.s3.ap-south-1.amazonaws.com/team_members/18/meet-img2.png",
      image_alt: "Girish Patil, financial maestro and multi-talented executive at AlgoAnalytics",
      designation: "Chief Financial Officer",
      description:
        "BE, PGDBA (Fin). Cross functional role including, Finance, Legal, Operations, HR,at AlgoAnalytics. More than 10+ years experience in equity research and quantitative trading.",
      linkedin_link: "https://www.linkedin.com/in/girish-patil-365b486/",
      role: "Management",
    },
    {
      name: "Anand Deshpande",
      image_url:
        "https://algoanalytics-bucket.s3.ap-south-1.amazonaws.com/team_members/20/meet-img4.png",
      image_alt: "Visionary strategist Anand Deshpande, shaping future innovations at AlgoAnalytics",
      designation: "Chief Strategy Officer",
      description:
        "PhD University of Colorado, USA. Expert in mathematical modeling with more than 25+ years of research and development experience in worldclass research organizations both in India and the USA.",
      linkedin_link: "https://www.linkedin.com/in/anand-m-deshpande/",
      role: "Management",
    },
  ];

  const advisors = [
    {
      name: "Kanchan Pant",
      Designation: "Advisor : Manufacturing",
      Description:
        "Kanchan's manufacturing know-how and connection with both OEMs and MSMEs in manufacturing helps us test our products/services and understand customer requirements",
      img: "assets/images/meet-img9.png",
      img_alt: "Kanchan Pant, manufacturing mastermind with OEM and MSME expertise at AlgoAnalytics",
      linkedin_link: "https://www.linkedin.com/in/kanchan-pant-b6066b2/",
    },
    {
      name: "Sayali Mahashur",
      Designation: "Advisor : Finance",
      Description:
        "Sayali is a finance domain expert and she is an advisor to us for our BFSI vertical business.",
      img: "assets/images/meet-img8.png",
      img_alt: "Sayali Mahashur, finance guru and advisor for BFSI at AlgoAnalytics",
      linkedin_link: "https://www.linkedin.com/in/sayali-mahashur-6028181b2/",
    },
  ];

  // useEffect(() => {
  //   // api.team_member
  //   //   .getTeamMember()
  //   //   .then((result) => {
  //   //     console.log("get team ", result);
  //   //     if (result.status === 1) {
  //   //       setTeamMemberList(result.data);
  //   //     }
  //   //   })
  //   //   .catch((error) => {
  //   //     console.log(error);
  //   //   });
  //   getTeamMembers();
  // }, []);

  // GET CAREER LIST
  // const getTeamMembers = () => {
  //   let URL = URLS.getTeamMembers;
  //   fetch(URL)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setTeamMemberList(data);
  //     });
  // };
  // console.log(teamMemberList);
  return [
    <Fragment>
      <div className='loader'>
        <div className='loader-inner'>
          <img
            src='assets/images/loader.gif'
            alt='Loader GIF'
            className='loader-img'
            loop='infinite'
          />
        </div>
      </div>
      {/* Meta Tags for SEO */}
      <Helmet>
        <title>About AlgoAnalytics | Pioneering Data Analytics and AI Solutions</title>
        <meta
          name='description'
          content='AlgoAnalytics, established in 2016, is a top-tier machine learning firm in India. Renowned for high-level predictive analytics and advanced AI solutions, we combine cutting-edge technology with deep domain expertise. Our elite team transforms data into valuable insights, driving significant results for global clients across industries.'
        />
        <meta
          name='keywords'
          content='Data Analytics, AI Solutions, Machine Learning, Predictive Analytics, Cloud Deployments, Generative AI, Industry-Specific AI, Data Science, Business Transformation, AI/ML Services'
        />
        <meta name='robots' content='index, follow' />
      </Helmet>
      <Navigation />
      <div className='about-hero-section serv-page-hero padding-top' id=''>
        <div className='container'>
          <div className='about-us-inner'>
            <div className='about-us-text'>
              <div className='serv-text text-left'>
                <h1 className='about-us-page-heading'>Pioneering Data Analytics and AI Solutions</h1>
                <p className='max-width-auto'>
                  Founded in 2016, AlgoAnalytics is one of the best
                  organizations in India as far as applied machine learning
                  expertise is concerned. We work at the intersection of
                  mathematics, computer science and multiple domain expertise.
                  We have developed expertise in handling various structured and
                  unstructured data types to gain intelligence for our global
                  clients. We integrate the cutting edge tools and technologies
                  with our strong domain expertise to design predictive
                  analytics solutions for businesses
                </p>
              </div>
            </div>
            <div className='about-us-video'>
              <div className='about-img justify-content-end'>
                <iframe
                  width='650'
                  height='400'
                  src='https://www.youtube.com/embed/ob4zQAcoTK0'
                  title='AlgoAnalytics: An Overview'
                  frameborder='0'
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                  referrerpolicy='strict-origin-when-cross-origin'
                  allowfullscreen>
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mission-section section'>
        <div className='container'>
          <div className='row mission-inner'>
            <div className='col-lg-6 col-md-12 mission-main'>
              <div className='mission-heading d-flex align-items-center'>
                <div className='mission-img'>
                  <svg
                    width='46'
                    height='46'
                    viewBox='0 0 46 46'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M22.9769 26.9044C25.0211 26.9044 26.6782 25.2468 26.6782 23.202C26.6782 21.1573 25.0211 19.4997 22.9769 19.4997C20.9327 19.4997 19.2755 21.1573 19.2755 23.202C19.2755 25.2468 20.9327 26.9044 22.9769 26.9044Z'
                      fill='#799BE6'
                    />
                    <path
                      d='M20.062 7.42069V5.29183C12.3816 6.54138 6.32062 12.604 5.07141 20.2864H7.1997C8.40264 13.761 13.5383 8.62396 20.062 7.42069Z'
                      fill='#799BE6'
                    />
                    <path
                      d='M38.7539 20.2864H40.8821C39.6329 12.604 33.5719 6.54138 25.8916 5.29183V7.42069C32.4153 8.62396 37.5509 13.761 38.7539 20.2864Z'
                      fill='#799BE6'
                    />
                    <path
                      d='M7.1997 26.1176H5.07141C6.32062 33.8 12.3816 39.8626 20.062 41.1122V38.9833C13.5383 37.7801 8.40264 32.643 7.1997 26.1176Z'
                      fill='#799BE6'
                    />
                    <path
                      d='M25.8916 38.9833V41.1122C33.5719 39.8626 39.6329 33.8 40.8821 26.1176H38.7539C37.5509 32.643 32.4153 37.7801 25.8916 38.9833Z'
                      fill='#799BE6'
                    />
                    <path
                      d='M43.8896 22.1376H34.5899C34.081 16.584 29.5931 12.0949 24.041 11.5859V2.28367C24.041 1.68203 23.5783 1.21924 22.9769 1.21924C22.3754 1.21924 21.9127 1.68203 21.9127 2.28367V11.6321C16.3607 12.0949 11.8728 16.584 11.3638 22.1376H2.06414C1.46267 22.1376 1 22.6004 1 23.202C1 23.8037 1.46267 24.2664 2.06414 24.2664H11.4101C11.8728 29.82 16.3607 34.3091 21.9127 34.8182V44.1667C21.9127 44.7683 22.3754 45.2311 22.9769 45.2311C23.5783 45.2311 24.041 44.7683 24.041 44.1667V34.8182C29.5931 34.3091 34.081 29.82 34.5899 24.2664H43.9359C44.5373 24.2664 45 23.8037 45 23.202C44.9537 22.6004 44.4911 22.1376 43.8896 22.1376ZM24.041 32.6893V30.7456C24.041 30.144 23.5783 29.6812 22.9769 29.6812C22.3754 29.6812 21.9127 30.144 21.9127 30.7456V32.6893C17.5174 32.1803 14.0011 28.663 13.4921 24.2664H15.4353C16.0368 24.2664 16.4995 23.8037 16.4995 23.202C16.4995 22.6004 16.0368 22.1376 15.4353 22.1376H13.4921C14.0011 17.741 17.5174 14.2238 21.9127 13.7147V15.6585C21.9127 16.2601 22.3754 16.7229 22.9769 16.7229C23.5783 16.7229 24.041 16.2601 24.041 15.6585V13.7147C28.4364 14.2238 31.9527 17.741 32.4616 22.1376H30.5184C29.9169 22.1376 29.4543 22.6004 29.4543 23.202C29.4543 23.8037 29.9169 24.2664 30.5184 24.2664H32.4616C31.9527 28.663 28.4364 32.1803 24.041 32.6893Z'
                      fill='#799BE6'
                    />
                    <path
                      d='M22.9769 26.9044C25.0211 26.9044 26.6782 25.2468 26.6782 23.202C26.6782 21.1573 25.0211 19.4997 22.9769 19.4997C20.9327 19.4997 19.2755 21.1573 19.2755 23.202C19.2755 25.2468 20.9327 26.9044 22.9769 26.9044Z'
                      stroke='#799BE6'
                      stroke-width='0.5'
                    />
                    <path
                      d='M20.062 7.42069V5.29183C12.3816 6.54138 6.32062 12.604 5.07141 20.2864H7.1997C8.40264 13.761 13.5383 8.62396 20.062 7.42069Z'
                      stroke='#799BE6'
                      stroke-width='0.5'
                    />
                    <path
                      d='M38.7539 20.2864H40.8821C39.6329 12.604 33.5719 6.54138 25.8916 5.29183V7.42069C32.4153 8.62396 37.5509 13.761 38.7539 20.2864Z'
                      stroke='#799BE6'
                      stroke-width='0.5'
                    />
                    <path
                      d='M7.1997 26.1176H5.07141C6.32062 33.8 12.3816 39.8626 20.062 41.1122V38.9833C13.5383 37.7801 8.40264 32.643 7.1997 26.1176Z'
                      stroke='#799BE6'
                      stroke-width='0.5'
                    />
                    <path
                      d='M25.8916 38.9833V41.1122C33.5719 39.8626 39.6329 33.8 40.8821 26.1176H38.7539C37.5509 32.643 32.4153 37.7801 25.8916 38.9833Z'
                      stroke='#799BE6'
                      stroke-width='0.5'
                    />
                    <path
                      d='M43.8896 22.1376H34.5899C34.081 16.584 29.5931 12.0949 24.041 11.5859V2.28367C24.041 1.68203 23.5783 1.21924 22.9769 1.21924C22.3754 1.21924 21.9127 1.68203 21.9127 2.28367V11.6321C16.3607 12.0949 11.8728 16.584 11.3638 22.1376H2.06414C1.46267 22.1376 1 22.6004 1 23.202C1 23.8037 1.46267 24.2664 2.06414 24.2664H11.4101C11.8728 29.82 16.3607 34.3091 21.9127 34.8182V44.1667C21.9127 44.7683 22.3754 45.2311 22.9769 45.2311C23.5783 45.2311 24.041 44.7683 24.041 44.1667V34.8182C29.5931 34.3091 34.081 29.82 34.5899 24.2664H43.9359C44.5373 24.2664 45 23.8037 45 23.202C44.9537 22.6004 44.4911 22.1376 43.8896 22.1376ZM24.041 32.6893V30.7456C24.041 30.144 23.5783 29.6812 22.9769 29.6812C22.3754 29.6812 21.9127 30.144 21.9127 30.7456V32.6893C17.5174 32.1803 14.0011 28.663 13.4921 24.2664H15.4353C16.0368 24.2664 16.4995 23.8037 16.4995 23.202C16.4995 22.6004 16.0368 22.1376 15.4353 22.1376H13.4921C14.0011 17.741 17.5174 14.2238 21.9127 13.7147V15.6585C21.9127 16.2601 22.3754 16.7229 22.9769 16.7229C23.5783 16.7229 24.041 16.2601 24.041 15.6585V13.7147C28.4364 14.2238 31.9527 17.741 32.4616 22.1376H30.5184C29.9169 22.1376 29.4543 22.6004 29.4543 23.202C29.4543 23.8037 29.9169 24.2664 30.5184 24.2664H32.4616C31.9527 28.663 28.4364 32.1803 24.041 32.6893Z'
                      stroke='#799BE6'
                      stroke-width='0.5'
                    />
                  </svg>
                </div>
                <h4>Our Vision</h4>
              </div>
              <div className='mission-para text-left'>
                <p>
                  Be one of the top analytics consultancy organizations which
                  operates in an ethically upright manner to create fair
                  economic value for all its stakeholders.
                </p>
              </div>
            </div>
            <div className='col-lg-6 col-md-12 mission-main'>
              <div className='mission-heading d-flex align-items-center'>
                <div className='mission-img'>
                  <svg
                    width='42'
                    height='42'
                    viewBox='0 0 42 42'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M29.887 18.3658C31.5574 16.7017 31.565 14.0009 29.8862 12.3292C28.2153 10.6638 25.5083 10.6626 23.8361 12.3292C22.1621 13.9962 22.1598 16.6975 23.8353 18.3658C25.5077 20.0311 28.2132 20.0325 29.887 18.3658ZM25.012 13.5102C26.0321 12.4924 27.6882 12.4929 28.7104 13.5102C29.7339 14.5298 29.7271 16.1719 28.7112 17.1848C27.7217 18.168 25.999 18.1693 25.0112 17.1844C23.9929 16.1717 23.9899 14.5267 25.012 13.5102Z'
                      fill='#799BE6'
                    />
                    <path
                      d='M2.15727 41.1649L10.3491 37.7045C11.2938 37.3036 12.1547 36.7196 12.9066 35.9695C13.1342 35.7425 13.3436 35.5045 13.5419 35.2561L16.5765 38.2787C16.7352 38.4362 16.9476 38.5216 17.1648 38.5216C17.2348 38.5216 17.3056 38.5127 17.3756 38.4944C17.6612 38.4199 17.8858 38.1993 17.9663 37.9153L20.2454 29.8656L25.9384 35.5361C26.0996 35.6965 26.3128 35.7791 26.5268 35.7791C26.6863 35.7791 26.8466 35.7335 26.9873 35.6399C32.2078 32.1736 33.9374 27.5485 32.1547 21.8924C35.0347 18.7684 37.2912 15.065 38.7807 10.9212L38.8205 10.8154C38.825 10.8034 38.8226 10.7912 38.8264 10.7792C38.8299 10.7688 38.837 10.7605 38.8401 10.7499L40.9265 3.472C41.0811 2.93398 40.9761 2.37032 40.6409 1.92469C40.2193 1.36591 39.4813 1.10179 38.7978 1.26987L31.2399 3.13787C31.2195 3.14296 31.2029 3.15538 31.1833 3.16179C31.1693 3.16626 31.1553 3.16352 31.1414 3.1688C26.9743 4.76831 23.2888 7.13221 20.2106 10.1121C14.4846 9.17652 9.38419 11.0573 6.49933 15.2026C6.26904 15.5346 6.30973 15.9839 6.59534 16.2692L12.4499 22.1007L4.22333 24.1954C3.93283 24.2695 3.70498 24.4941 3.62524 24.7835C3.54631 25.0729 3.6285 25.3821 3.84088 25.5938L6.99651 28.7368C5.92117 29.5909 5.05333 30.6862 4.53499 31.9157L1.06689 40.0706C0.933432 40.3831 1.00342 40.7449 1.24346 40.9855C1.40296 41.1454 1.61615 41.2305 1.83342 41.2305C1.94244 41.2305 2.05311 41.2089 2.15727 41.1649ZM31.414 4.85937C34.1176 6.10938 35.9949 7.97739 37.1361 10.5529C35.6767 14.5245 33.4801 18.0655 30.676 21.0332C30.6556 21.0504 30.6397 21.0698 30.6214 21.0888C27.8658 23.99 24.5319 26.3416 20.7404 28.0055C20.5479 27.8138 14.8536 22.142 14.6667 21.9559L14.6659 21.9551L14.388 21.6785C17.5298 14.0011 23.4555 8.01446 31.414 4.85937ZM26.6244 33.8663L21.9978 29.258C25.3021 27.7302 28.2706 25.7094 30.8159 23.2639C31.9173 27.6273 30.571 31.0358 26.6244 33.8663ZM39.2282 2.88392C39.273 2.88392 39.3023 2.9177 39.3096 2.92828C39.3348 2.96124 39.3316 2.98973 39.3251 3.01252L37.8188 8.26449C36.8049 6.63376 35.4509 5.28505 33.7697 4.23059L39.2282 2.88392ZM18.7569 11.6043C16.4345 14.1707 14.534 17.1328 13.1137 20.4093L8.283 15.5977C10.6396 12.6516 14.4364 11.2177 18.7569 11.6043ZM13.8253 23.4706L18.8948 28.5201L16.749 36.0977L6.05746 25.4489L13.8253 23.4706ZM6.06885 32.566C6.50521 31.5325 7.25526 30.6177 8.18678 29.9223L9.67407 31.4037L7.74431 33.3238C7.41801 33.6486 7.41638 34.1764 7.74105 34.5024C8.0624 34.8262 8.58967 34.8329 8.91933 34.5056L10.8548 32.5797L12.3486 34.0675C12.1569 34.3209 11.9559 34.5638 11.7299 34.7893C11.1294 35.388 10.4459 35.8527 9.69969 36.1693L3.40634 38.8277L6.06885 32.566Z'
                      fill='#799BE6'
                    />
                    <path
                      d='M29.887 18.3658C31.5574 16.7017 31.565 14.0009 29.8862 12.3292C28.2153 10.6638 25.5083 10.6626 23.8361 12.3292C22.1621 13.9962 22.1598 16.6975 23.8353 18.3658C25.5077 20.0311 28.2132 20.0325 29.887 18.3658ZM25.012 13.5102C26.0321 12.4924 27.6882 12.4929 28.7104 13.5102C29.7339 14.5298 29.7271 16.1719 28.7112 17.1848C27.7217 18.168 25.999 18.1693 25.0112 17.1844C23.9929 16.1717 23.9899 14.5267 25.012 13.5102Z'
                      stroke='#799BE6'
                      stroke-width='0.5'
                    />
                    <path
                      d='M2.15727 41.1649L10.3491 37.7045C11.2938 37.3036 12.1547 36.7196 12.9066 35.9695C13.1342 35.7425 13.3436 35.5045 13.5419 35.2561L16.5765 38.2787C16.7352 38.4362 16.9476 38.5216 17.1648 38.5216C17.2348 38.5216 17.3056 38.5127 17.3756 38.4944C17.6612 38.4199 17.8858 38.1993 17.9663 37.9153L20.2454 29.8656L25.9384 35.5361C26.0996 35.6965 26.3128 35.7791 26.5268 35.7791C26.6863 35.7791 26.8466 35.7335 26.9873 35.6399C32.2078 32.1736 33.9374 27.5485 32.1547 21.8924C35.0347 18.7684 37.2912 15.065 38.7807 10.9212L38.8205 10.8154C38.825 10.8034 38.8226 10.7912 38.8264 10.7792C38.8299 10.7688 38.837 10.7605 38.8401 10.7499L40.9265 3.472C41.0811 2.93398 40.9761 2.37032 40.6409 1.92469C40.2193 1.36591 39.4813 1.10179 38.7978 1.26987L31.2399 3.13787C31.2195 3.14296 31.2029 3.15538 31.1833 3.16179C31.1693 3.16626 31.1553 3.16352 31.1414 3.1688C26.9743 4.76831 23.2888 7.13221 20.2106 10.1121C14.4846 9.17652 9.38419 11.0573 6.49933 15.2026C6.26904 15.5346 6.30973 15.9839 6.59534 16.2692L12.4499 22.1007L4.22333 24.1954C3.93283 24.2695 3.70498 24.4941 3.62524 24.7835C3.54631 25.0729 3.6285 25.3821 3.84088 25.5938L6.99651 28.7368C5.92117 29.5909 5.05333 30.6862 4.53499 31.9157L1.06689 40.0706C0.933432 40.3831 1.00342 40.7449 1.24346 40.9855C1.40296 41.1454 1.61615 41.2305 1.83342 41.2305C1.94244 41.2305 2.05311 41.2089 2.15727 41.1649ZM31.414 4.85937C34.1176 6.10938 35.9949 7.97739 37.1361 10.5529C35.6767 14.5245 33.4801 18.0655 30.676 21.0332C30.6556 21.0504 30.6397 21.0698 30.6214 21.0888C27.8658 23.99 24.5319 26.3416 20.7404 28.0055C20.5479 27.8138 14.8536 22.142 14.6667 21.9559L14.6659 21.9551L14.388 21.6785C17.5298 14.0011 23.4555 8.01446 31.414 4.85937ZM26.6244 33.8663L21.9978 29.258C25.3021 27.7302 28.2706 25.7094 30.8159 23.2639C31.9173 27.6273 30.571 31.0358 26.6244 33.8663ZM39.2282 2.88392C39.273 2.88392 39.3023 2.9177 39.3096 2.92828C39.3348 2.96124 39.3316 2.98973 39.3251 3.01252L37.8188 8.26449C36.8049 6.63376 35.4509 5.28505 33.7697 4.23059L39.2282 2.88392ZM18.7569 11.6043C16.4345 14.1707 14.534 17.1328 13.1137 20.4093L8.283 15.5977C10.6396 12.6516 14.4364 11.2177 18.7569 11.6043ZM13.8253 23.4706L18.8948 28.5201L16.749 36.0977L6.05746 25.4489L13.8253 23.4706ZM6.06885 32.566C6.50521 31.5325 7.25526 30.6177 8.18678 29.9223L9.67407 31.4037L7.74431 33.3238C7.41801 33.6486 7.41638 34.1764 7.74105 34.5024C8.0624 34.8262 8.58967 34.8329 8.91933 34.5056L10.8548 32.5797L12.3486 34.0675C12.1569 34.3209 11.9559 34.5638 11.7299 34.7893C11.1294 35.388 10.4459 35.8527 9.69969 36.1693L3.40634 38.8277L6.06885 32.566Z'
                      stroke='#799BE6'
                      stroke-width='0.5'
                    />
                  </svg>
                </div>
                <h4>Our Mission</h4>
              </div>
              <div className='mission-para text-left'>
                <p>
                  To serve our clients by effectively delivering superior
                  value-adding solutions for analytical problems using our
                  expertise in data science and machine learning.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ceo section */}
      <div className='ceo-main-container section'>
        <div className='container'>
          <div className='ceo-inner'>
            <div className='ceo-top d-flex align-items-center'>
              <div className=''>
                <img
                  src='assets/images/ceo-img.png'
                  className='ceo-img img-fluid'
                  alt='img'
                />
              </div>
              <div className='ceo-heading text-left'>
                <h4>From the CEO's desk</h4>
                <span></span>
              </div>
            </div>
            <div className='ceo-mid'>
              <div className='ceo-para'>
                <p className='text-left'>
                  We started AlgoAnalytics in May 2016. Since then we have seen
                  ups and downs in our fortune however, our guiding principle
                  has always been to create an organization which operates in an
                  upright manner and is fair to all the stakeholders Clients,
                  Employees and Promoters. We believe this is the only thing
                  which make existence of AlgoAnalytics worthwhile.
                </p>
              </div>
            </div>
            <div className='ceo-bottom d-flex align-items-center'>
              <div className='ceo-para'>
                <p className='text-left'>
                  Our passion is to operate at the intersection of computer
                  science, mathematics and domain knowledge to create solutions
                  which make non-trivial change to the top-line and bottom-line
                  of our clients.
                </p>
                <p className='text-left'>
                  We work on the application of data science across domains. We
                  have worked on problems from almost all industries. We have
                  worked in medicine, we have worked on financial markets and we
                  have analyzed click-stream data. If you have data and if you
                  suspect there is lot of information in the data which you
                  would like to visualize and use to perform predictive and
                  prescriptive analytics, we can certainly work with you to make
                  that happen.
                </p>
                <div className='ceo-name text-left'>
                  <h5>Aniruddha Pant, Phd.</h5>
                  <span>CEO, AlgoAnalytics Pvt. Ltd.</span>
                </div>
              </div>
              {/* <div className='ceo-bottom-img'>
                <img
                  src='assets/images/ceo-b-img.png'
                  alt='image'
                  className='img-fluid'
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* meet section */}
      <div id='team' style={{ padding: "2rem" }}></div>
      <div className='meet-main-container section-bottom'>
        <div className='meet-section section'>
          <div className='container '>
            <h2 className='sub-heading text-center mb-5'>
              Meet the minds behind AlgoAnalytics
            </h2>
            {/* {console.log('role', teamMemberList)} */}

            <h2 className='sub-heading text-center mb-2'>Management</h2>
            <div
              className='d-flex justify-content-start meet-top'
              style={{ flexWrap: "wrap", gap: "0.5rem" }}>
              {management &&
                management.map((team, idx) => {
                  return (
                    <div className='meet-card mr-2'>
                      <div className='meet-img d-flex align-items-center justify-content-center'>
                        <img
                          style={{
                            borderRadius: "50%",
                            width: "10rem",
                            height: "10rem",
                          }}
                          src={team.image_url}
                          alt={team.image_alt || "management"}
                          className='img-fluid'
                        />
                      </div>
                      <div className='meet-name'>
                        <h4>{team.name}</h4>
                        <span>{team.designation}</span>
                      </div>
                      <div className='meet-para'>
                        <p>{team.description}</p>
                      </div>
                      {team.linkedin_link && (
                        <ul className='social-meet'>
                          <li>
                            <a
                              href={
                                team.linkedin_link.includes("https://")
                                  ? team.linkedin_link
                                  : `https://${team.linkedin_link}`
                              }
                              target='_blank'
                              rel='noreferrer'
                              className='m-auto d-flex justify-content-center'>
                              <svg
                                width='28'
                                height='28'
                                viewBox='0 0 28 28'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'>
                                <path
                                  d='M24.6667 0H3.33333C1.49333 0 0 1.49333 0 3.33333V24.6667C0 26.5067 1.49333 28 3.33333 28H24.6667C26.5067 28 28 26.5067 28 24.6667V3.33333C28 1.49333 26.5067 0 24.6667 0ZM8.66667 10.6667V23.3333H4.66667V10.6667H8.66667ZM4.66667 6.98C4.66667 6.04667 5.46667 5.33333 6.66667 5.33333C7.86667 5.33333 8.62 6.04667 8.66667 6.98C8.66667 7.91333 7.92 8.66667 6.66667 8.66667C5.46667 8.66667 4.66667 7.91333 4.66667 6.98ZM23.3333 23.3333H19.3333C19.3333 23.3333 19.3333 17.16 19.3333 16.6667C19.3333 15.3333 18.6667 14 17 13.9733H16.9467C15.3333 13.9733 14.6667 15.3467 14.6667 16.6667C14.6667 17.2733 14.6667 23.3333 14.6667 23.3333H10.6667V10.6667H14.6667V12.3733C14.6667 12.3733 15.9533 10.6667 18.54 10.6667C21.1867 10.6667 23.3333 12.4867 23.3333 16.1733V23.3333Z'
                                  fill='#537EDF'
                                />
                              </svg>
                            </a>
                          </li>
                        </ul>
                      )}
                    </div>
                  );
                })}
            </div>

            <h2
              className='sub-heading text-center mt-5'
              style={{ margin: "20px 0", padding: 0, lineHeight: 0 }}>
              Advisors
            </h2>
            <div
              className='d-flex justify-content-center meet-top'
              style={{ flexWrap: "wrap", gap: "0.5rem" }}>
              {advisors &&
                advisors.map((team, idx) => {
                  return (
                    <div className='meet-card mr-2'>
                      <div className='meet-img d-flex align-items-center justify-content-center'>
                        <img
                          style={{
                            borderRadius: "50%",
                            width: "10rem",
                            height: "10rem",
                          }}
                          src={team.img}
                          alt={team.img_alt || "advisors"}
                          className='img-fluid'
                        />
                      </div>
                      <div className='meet-name'>
                        <h4>{team.name}</h4>
                        <span>{team.Designation}</span>
                      </div>
                      <div className='meet-para'>
                        <p>{team.Description}</p>
                      </div>
                      {team.linkedin_link && (
                        <ul className='social-meet'>
                          <li>
                            <a
                              href={
                                team.linkedin_link.includes("https://")
                                  ? team.linkedin_link
                                  : `https://${team.linkedin_link}`
                              }
                              target='_blank'
                              rel='noreferrer'
                              className='m-auto d-flex justify-content-center'>
                              <svg
                                width='28'
                                height='28'
                                viewBox='0 0 28 28'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'>
                                <path
                                  d='M24.6667 0H3.33333C1.49333 0 0 1.49333 0 3.33333V24.6667C0 26.5067 1.49333 28 3.33333 28H24.6667C26.5067 28 28 26.5067 28 24.6667V3.33333C28 1.49333 26.5067 0 24.6667 0ZM8.66667 10.6667V23.3333H4.66667V10.6667H8.66667ZM4.66667 6.98C4.66667 6.04667 5.46667 5.33333 6.66667 5.33333C7.86667 5.33333 8.62 6.04667 8.66667 6.98C8.66667 7.91333 7.92 8.66667 6.66667 8.66667C5.46667 8.66667 4.66667 7.91333 4.66667 6.98ZM23.3333 23.3333H19.3333C19.3333 23.3333 19.3333 17.16 19.3333 16.6667C19.3333 15.3333 18.6667 14 17 13.9733H16.9467C15.3333 13.9733 14.6667 15.3467 14.6667 16.6667C14.6667 17.2733 14.6667 23.3333 14.6667 23.3333H10.6667V10.6667H14.6667V12.3733C14.6667 12.3733 15.9533 10.6667 18.54 10.6667C21.1867 10.6667 23.3333 12.4867 23.3333 16.1733V23.3333Z'
                                  fill='#537EDF'
                                />
                              </svg>
                            </a>
                          </li>
                        </ul>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <div id='careers' style={{ padding: "1rem" }}></div>
      </div>

      {/* bottom section */}
      <div className='bottom-section section-bottom'>
        <div className='container'>
          <div className='about-bottom-text'>
            <h4>Join the team at AlgoAnalytics</h4>
            <p>
              Be a part of our growing team of geeks and machine learning <br />
              enthusiasts who enjoy working in a dynamic setting
            </p>
          </div>
          <a href='/careers' className='btn-all btn-light-blue mx-auto'>
            Explore careers{" "}
          </a>
        </div>
      </div>

      {/* footer */}
      <Footer />
      {/* bottom button */}

      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a className='back-top' href='#'>
        <i className='fa fa-angle-up'></i>
      </a>
    </Fragment>,
  ];
};
export default About;
